import React from 'react'

import {
  CreateWashingMachinePartForm,
  CreateWashingMachinePartPageHeader,
} from '@/components/pages/WashingMachinePart/Create'

import { useCreateWashingMachinePart } from './Create.hooks'

const CreateWashingMachinePart = () => {
  const { createWashingMachinePart, loading } = useCreateWashingMachinePart()

  return (
    <>
      <CreateWashingMachinePartPageHeader />
      <CreateWashingMachinePartForm {...{ loading }} onSubmit={createWashingMachinePart} />
    </>
  )
}

CreateWashingMachinePart.displayName = 'CreateWashingMachinePart'
export default CreateWashingMachinePart
